//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWheelHistory } from "@/api";
import UiGameHistoryGame from './components/UiGameHistoryGame.vue';
import WheelHistoryRoundColors from './WheelHistoryRoundColors.vue';

export default {
    name: 'WheelHistory',
    components: {
        WheelHistoryRoundColors,
        UiGameHistoryGame
    },
    data() {
        return {
            isLoading: false,
            preloadGames: new Array(20),
            windowWidth: window.innerWidth
        };
    },
    async created() {
        this.isLoading = true;
        try {
            await this.fetchHistory();
        } finally {
            this.isLoading = false;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        isLg() {
            return this.windowWidth <= 991;
        },
        currencyType() {
            return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
        },
        currencyTypeLabel() {
            if (this.currencyType === 1) return '欢乐豆';
            if (this.currencyType === 2) return '金豆';
            return '现金';
        },
        gameData() {
            return this.wheelState.game;
        }
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        async fetchHistory() {
            try {
                const data = await getWheelHistory({ pageIndex: 0, pageSize: 100, currencyType: this.currencyType });
                console.log(data);
                this.historyPageGames = data.data.data.games;

                console.warn(this.historyPageGames);

            } catch (error) {
                console.log("There was an error while loading crash schema:", error);
            }
        },
    }
};
